module.exports = __webpack_public_path__ + "img/holiday-3.b326b946.svg";